export const onNotBackdropClickWrap = (onCloseHandler: () => void) => {
    return (event: Record<string, unknown>, reason: string): void => {
        if (reason !== 'backdropClick') {
            onCloseHandler();
        }
    };
};

export const onBackdropClickWrap = (onCloseHandler: () => void) => {
    return (event: Record<string, unknown>, reason: string): void => {
        if (reason === 'backdropClick') {
            onCloseHandler();
        }
    };
};
